import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '../utils/supabase';
import type { Player, UsePlayersReturn } from '../types';

export function usePlayers(): UsePlayersReturn {
  const [players, setPlayers] = useState<Player[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { loading: authLoading } = useAuth();

  const fetchPlayers = async (): Promise<void> => {
    try {
      setLoading(true);
      setError(null);
      console.log('Fetching players...');
      
      const { data, error: supabaseError } = await supabase.rpc('get_players');
      
      if (supabaseError) {
        console.error('Supabase error:', supabaseError);
        throw supabaseError;
      }
      
      console.log('Players fetched successfully:', data?.length || 0);
      setPlayers(data || []);
    } catch (err) {
      console.error('Error fetching players:', err);
      setError(err instanceof Error ? err : new Error('Failed to fetch players'));
    } finally {
      setLoading(false);
    }
  };

  const refetch = async () => {
    await fetchPlayers();
  };

  const clearError = () => {
    setError(null);
  };

  const retryLastOperation = async () => {
    await fetchPlayers();
  };

  useEffect(() => {
    console.log('usePlayers useEffect - authLoading:', authLoading);
    if (!authLoading) {
      fetchPlayers();
    }
  }, [authLoading]);

  return {
    players,
    loading: loading || authLoading,
    error,
    refetch,
    clearError,
    retryLastOperation,
  };
}